import type { App } from 'vue';

const PRESSABLE_SELECTOR = 'button, a[href], [role="button"], [data-pressable]';
const NO_PRESS_ATTR = 'data-no-pressable';
const PRESSED_CLASS = 'is-pressed';

// Tracks currently pressed element per pointer ID so multi-touch is handled correctly
const pressedElements = new Map<number, HTMLElement>();

function findPressableTarget(target: EventTarget | null): HTMLElement | null {
  let el = target as HTMLElement | null;

  while (el && el !== document.body) {
    // Opt-out: stop walking if we hit an exclusion boundary
    if (el.hasAttribute(NO_PRESS_ATTR)) return null;

    if (el.matches(PRESSABLE_SELECTOR)) return el;

    el = el.parentElement;
  }

  return null;
}

function onPointerDown(event: PointerEvent): void {
  const target = findPressableTarget(event.target);
  if (!target) return;

  target.classList.add(PRESSED_CLASS);
  pressedElements.set(event.pointerId, target);
}

function releasePointer(pointerId: number): void {
  const target = pressedElements.get(pointerId);
  if (target) {
    target.classList.remove(PRESSED_CLASS);
    pressedElements.delete(pointerId);
  }
}

function onPointerUp(event: PointerEvent): void {
  releasePointer(event.pointerId);
}

function onPointerCancel(event: PointerEvent): void {
  releasePointer(event.pointerId);
}

export const pressAnimationPlugin = {
  install(_app: App): void {
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerCancel);
  },
};
